import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import {
  ClearButton,
  SelectDropDown,
  DatePicker
} from 'components/common/Elements/Elements';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter,
  trigerResetDatePicker
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 7;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateChange = key => value => {
    checkAndSetFilter(key, value);
  };
  const createFilterAction = filters => {
    return filters
      ? filters
          .map(item => ({
            value: item,
            label: t(`activity:cm.ACTION-${item.trim().toUpperCase()}`)
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      : [];
  };

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={createFilterAction(filters.action)}
        input={{ value: filter.action, onChange: handleFilter }}
        name={'action'}
        label={t('activity:filters.ACTION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.status}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.CREATED_AT')}
        input={{
          value: Array.isArray(filter.datetime)
            ? { startDate: null, endDate: null }
            : filter.datetime,
          onChange: handleDateChange('datetime')
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={filters.networkVersion}
        input={{ value: filter.networkVersion, onChange: handleFilter }}
        name={'networkVersion'}
        label={t('activity:filters.NETWORK_VERSION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters['entities.gatewayImageVersion']}
        input={{
          value: filter['entities.gatewayImageVersion'],
          onChange: handleFilter
        }}
        name={'entities.gatewayImageVersion'}
        label={t('activity:filters.GATEWAY_IMAGE_VERSION')}
        multi
        searchable
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.batchId}
        input={{ value: filter.batchId, onChange: handleFilter }}
        name={'batchId'}
        label={t('activity:filters.BATCH_ID')}
        multi
        searchable
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
        capitalize={false}
      />
      <SelectDropDown
        options={filters.updatedByName}
        input={{ value: filter.updatedByName, onChange: handleFilter }}
        name={'updatedByName'}
        label={t('activity:filters.UPDATED_BY')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={
          filters['isTestTenant']
            ? filters['isTestTenant'].map(item =>
                item === true ? 'True' : 'False'
              )
            : []
        }
        input={{ value: filter.isTestTenant, onChange: handleFilter }}
        name={'isTestTenant'}
        label={t('activity:filters.IS_TEST_TENANT')}
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
        defaultValue={'False'}
      />
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
